import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaEdit, FaTrash } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';

const SetoresFuncional = () => {
  const [setores, setSetores] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    setor: '',
    ativo: true
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const carregarSetores = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/setores`);
      if (!response.ok) {
        throw new Error('Erro ao buscar setores');
      }
      const data = await response.json();
      const formatados = data.map((item) => ({
        id: item.id_setor,
        setor: item.nome_setor,
        ativo: item.ativo
      }));
      setSetores(formatados);
    } catch (error) {
      console.error('Erro ao carregar setores:', error);
      alert('Erro ao carregar setores. Verifique a conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarSetores();
  }, []);

  const filteredSetoresFuncional = setores.filter((setor) =>
    (setor.setor || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);
      const payload = {
        nome_setor: formData.setor,
        ativo: formData.ativo
      };

      if (editingId) {
        const response = await fetch(
          `${API_BASE_URL}/setores/${editingId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar setor');
        }

        const atualizado = await response.json();

        setSetores(
          setores.map((setor) =>
            setor.id === editingId
              ? {
                  id: atualizado.id_setor,
                  setor: atualizado.nome_setor,
                  ativo: atualizado.ativo
                }
              : setor
          )
        );
      } else {
        const response = await fetch(`${API_BASE_URL}/setores`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erro ao criar setor');
        }

        const criado = await response.json();

        setSetores([
          ...setores,
          {
            id: criado.id_setor,
            setor: criado.nome_setor,
            ativo: criado.ativo
          }
        ]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar setor:', error);
      alert('Erro ao salvar setor. Verifique os dados e tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (setor) => {
    setFormData({
      setor: setor.setor,
      ativo: setor.ativo
    });
    setEditingId(setor.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir este setor?')) {
      try {
        const response = await fetch(
          `${API_BASE_URL}/setores/${id}`,
          {
            method: 'DELETE'
          }
        );

        if (!response.ok && response.status !== 204) {
          throw new Error('Erro ao excluir setor');
        }

        setSetores(setores.filter((setor) => setor.id !== id));
      } catch (error) {
        console.error('Erro ao excluir setor:', error);
        alert('Erro ao excluir setor. Tente novamente.');
      }
    }
  };

  const resetForm = () => {
    setFormData({ setor: '', ativo: true });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (id) => {
    const setorSelecionado = setores.find((s) => s.id === id);
    if (!setorSelecionado) {
      return;
    }

    const novoAtivo = !setorSelecionado.ativo;

    try {
      const response = await fetch(`${API_BASE_URL}/setores/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          nome_setor: setorSelecionado.setor,
          ativo: novoAtivo
        })
      });

      if (!response.ok) {
        throw new Error('Erro ao atualizar status do setor');
      }

      setSetores(
        setores.map((setor) =>
          setor.id === id ? { ...setor, ativo: novoAtivo } : setor
        )
      );
    } catch (error) {
      console.error('Erro ao atualizar status do setor:', error);
      alert('Erro ao atualizar status do setor. Tente novamente.');
    }
  };

  return (
    <div className="tabela-referencia-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Setores</h1>
        </div>
        {!showForm && (
          <button 
            className="btn-primary"
            onClick={() => setShowForm(true)}
            disabled={saving}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            Cadastrar Setor
          </button>
        )}
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Setor' : 'Cadastrar Setor'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="setor">Setor *</label>
              <input
                type="text"
                id="setor"
                value={formData.setor}
                onChange={(e) => setFormData({ ...formData, setor: e.target.value })}
                required
                maxLength={60}
                placeholder="Digite o nome do setor"
              />
            </div>

            <div className="form-group">
              <Toggle
                id="ativo"
                label="Status:"
                checked={formData.ativo}
                onChange={(e) => setFormData({ ...formData, ativo: e.target.checked })}
              />
            </div>

            <div className="form-actions">
              <button
                type="button"
                className="btn-secondary"
                onClick={resetForm}
                disabled={saving}
              >
                Cancelar
              </button>
              <button type="submit" className="btn-primary" disabled={saving}>
                {editingId ? 'Atualizar' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
              <input
                type="text"
                placeholder="Pesquisar setores..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>
                {loading
                  ? 'Carregando setores...'
                  : `${filteredSetoresFuncional.length} registro(s) encontrado(s)`}
              </span>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Setor</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredSetoresFuncional.map((setor) => (
                  <tr key={setor.id}>
                    <td>{setor.id}</td>
                    <td>{setor.setor}</td>
                    <td className="status-cell">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          checked={setor.ativo}
                          onChange={() => handleToggleStatus(setor.id)}
                          id={`toggle-${setor.id}`}
                        />
                      </div>
                    </td>
                    <td className="acoes-col">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(setor)}
                          title="Editar"
                        >
                          <FaEdit size={16} />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(setor.id)}
                          title="Excluir"
                        >
                          <FaTrash size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredSetoresFuncional.length === 0 && !loading && (
              <div className="empty-state">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="M21 21l-4.35-4.35"/>
                </svg>
                <h3>Nenhum setor encontrado</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre um novo setor.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SetoresFuncional;
